/** Utility functions for the frontend */

import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Extract URL from deployment content
export const extractDeploymentUrl = (content: string | undefined) => {
  if (!content) {
    return null;
  }
  const urlMatch = content.match(/https:\/\/[^\s]+\.fp\.dev[^\s]*/);
  return urlMatch ? urlMatch[0] : null;
};
